module.exports = __webpack_public_path__ + "static/source-sans-pro-latin-400-76d8cbb0496cb184eff868152b67ad45.woff2";